import { render, staticRenderFns } from "./oddsWave.vue?vue&type=template&id=4d89f3d8&"
import script from "./oddsWave.vue?vue&type=script&lang=js&"
export * from "./oddsWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports